module.exports = __webpack_public_path__ + "img/Vorbau.a1ab3ac9.jpg";